export default __webpack_public_path__ + "static/media/ra.a1aec9df.jpg";